import React from "react";
import PropTypes from "prop-types";
import Fieldset from "../common/Fieldset";
import Row from "../common/Row";
import Dropdown from "../common/Dropdown";
import TextInput from "../common/TextInput";
import InfrastructurenInDeBuurtTable from "./InfrastructurenTabel";
import NieuwbowInfrastructurenTable from "./NieuwbouwInfrastructurenTabel";
import VerdwijnendeInfrastructurenTable from "./VerdwijnendeInfrastructurenTable";
import Button from "../common/Button";
import Tooltip from "../common/Tooltip";
import CheckBoxWithChild from "../common/CheckBoxWithChild";
import FieldsetSubHeader from "../common/FieldsetSubHeader";
import ValidationGroup from "../common/ValidationGroup";
import * as types from "../../constants/ComponentConstants";
import * as domainConstants from "../../constants/DomainConstants";
import Map from "../common/map/Map";
import Markers from "../common/map/Markers";

const AdresFieldset = (props) => {

    const {
        simulatieDossier,
        postcodes,
        gemeenten,
        errors,
        disabled,
        onChange,
        onChangeRenovatieTable,
        onChangeVerdwijnendeInfrasTable,
        onEditInfrastructuur,
        onAddNieuwbouwInfrastructuur,
        onDeleteNieuwbouwInfrastructuur,
        onGetGeoCoordinates,
        center,
        mapKey,
        soortenInfrastructuur,
		soortenInfrastructuurAll,
        onAddInfrastructuur,
        onReplacePoint,
        saveNewPoint,
        cancelReplace,
        inEditMode,
        newCoords,
        geoToolboxUrl,
        maxMapFeaturesToLoad,
        osmBaseLayerUrl,
        onMarkerDragEnd,
        validationMessageType
    } = props;

    const hasCoordinates = newCoords.lat && newCoords.lng;

    function mapOnGetGeoCoordinates() {
        return onGetGeoCoordinates(event);
    }


    if (simulatieDossier.sportinfrastructurenOpKaart == null) {
        simulatieDossier.sportinfrastructurenOpKaart = [];
    }

    if (simulatieDossier.sportinfrastructurenInDeBuurt == null) {
        simulatieDossier.sportinfrastructurenInDeBuurt = [];
    }

    const sportInfrastructurenNieuwbouw = simulatieDossier.sportinfrastructurenInDeBuurt.filter(i => i.soortWerken === domainConstants.INFRASTRUCTUUR_TYPE.NIEUWBOUW);
    const sportInfrastructurenRenovatie = simulatieDossier.sportinfrastructurenInDeBuurt.filter(i => i.soortWerken !== domainConstants.INFRASTRUCTUUR_TYPE.NIEUWBOUW);
    const isNieuwbouw = simulatieDossier.soortDossier && (simulatieDossier.soortDossier.toString() === domainConstants.DOSSIER_SOORT_NIEUWBOUW.toString() || simulatieDossier.soortDossier.toString() === domainConstants.DOSSIER_SOORT_NIEUWBOUWRENOVATIE.toString());
    const isRenovatie = simulatieDossier.soortDossier && (simulatieDossier.soortDossier.toString() === domainConstants.DOSSIER_SOORT_RENOVATIE.toString() || simulatieDossier.soortDossier.toString() === domainConstants.DOSSIER_SOORT_NIEUWBOUWRENOVATIE.toString());
    const rozeInfras = simulatieDossier.sportinfrastructurenOpKaart.filter(s => (s.deelVanAanvraag != null && s.deelVanAanvraag !== undefined && (s.deelVanAanvraag.toString() === domainConstants.DeelVanAanvraag.Ja.toString())) || (!s.deelVanAanvraag == null || s.deelVanAanvraag == undefined));
    const blauweInfras = simulatieDossier.sportinfrastructurenOpKaart.filter(s => s.deelVanAanvraag != null && s.deelVanAanvraag !== undefined && (s.deelVanAanvraag.toString() === domainConstants.DeelVanAanvraag.Nee.toString() || s.deelVanAanvraag.toString() === domainConstants.DeelVanAanvraag.Reconversie.toString() && !rozeInfras.find(r => r.naam === s.naam)));

    const markersToShow = [];

    let ulProps = {
        style: {
            "list-style-type": "none",
            "font-size": "14px"
        }
    };

    if (inEditMode !== true) {
        blauweInfras.forEach((sportinfrastructuur) => {
            if (sportinfrastructuur.breedtegraad && sportinfrastructuur.lengtegraad) {
                const namen = [...(simulatieDossier.sportinfrastructurenOpKaart.filter(s => (s.lengtegraad === sportinfrastructuur.lengtegraad && s.breedtegraad === sportinfrastructuur.breedtegraad))
                    .map(x => x.naam))];
                const tooltipText = <div><ul {...ulProps}>{namen.map(n => <li>{n}</li>)}</ul></div>;

                markersToShow.push({
                    lat: parseFloat(sportinfrastructuur.breedtegraad),
                    long: parseFloat(sportinfrastructuur.lengtegraad),
                    tooltip: tooltipText,
                    size: 'x-large',
                    color: types.COLOR_BLUE
                });
            }
        });

        markersToShow.push(
            {
                lat: parseFloat(newCoords.lat),
                long: parseFloat(newCoords.lng),
                size: 'x-large',
                color: types.COLOR_ORANGE,
                draggable: inEditMode,
                onDragEnd: onMarkerDragEnd
            }
        );

        rozeInfras.forEach((sportinfrastructuur) => {
            if (sportinfrastructuur.breedtegraad && sportinfrastructuur.lengtegraad) {
                const namen = [...new Set(simulatieDossier.sportinfrastructurenOpKaart.filter(s => (s.lengtegraad === sportinfrastructuur.lengtegraad && s.breedtegraad === sportinfrastructuur.breedtegraad))
                    .map(x => x.naam))];
                const tooltipText = <div><ul {...ulProps}>{namen.map(n => <li>{n}</li>)}</ul></div>;

                markersToShow.push({
                    lat: parseFloat(sportinfrastructuur.breedtegraad),
                    long: parseFloat(sportinfrastructuur.lengtegraad),
                    tooltip: tooltipText,
                    size: 'x-large',
                    color: types.COLOR_PINK
                });
            }
        });
    }
    else {
        markersToShow.push(
            {
                lat: parseFloat(newCoords.lat),
                long: parseFloat(newCoords.lng),
                size: 'x-large',
                color: types.COLOR_ORANGE,
                draggable: inEditMode,
                onDragEnd: onMarkerDragEnd
            }
        );
    }

    const mijnProjectMarkers = <Markers markersToShow={markersToShow} />;

    const WIJZIG_MAP = "Druk op wijzig om de locatie van het project te wijzigen.";

    return (<Fieldset title="Adres en ligging van het project">
        <TextInput
            label="Straat en huisnummer"
            name="straatHuisnummer"
            disabled={disabled}
            value={simulatieDossier ? simulatieDossier.straatHuisnummer : null}
            onChange={onChange}
            size={12}
            validationMessage={errors ? errors.straatHuisnummer : ''}
            validationMessageType={validationMessageType}
            maxLength={200}
        />
        <Row>
            <Dropdown
                label="Postcode"
                name="postcode"
                onChange={onChange}
                value={simulatieDossier ? simulatieDossier.postcode : null}
                size={4}
                items={postcodes}
                disabled={disabled}
                validationMessage={errors ? errors.postcode : ''}
                validationMessageType={validationMessageType}
                noResultsMessage="Tik (2 cijfers) en zoek"
            />
            <Dropdown
                label="Gemeente"
                name="gemeente"
                onChange={onChange}
                disabled={disabled}
                value={simulatieDossier ? simulatieDossier.gemeente : null}
                size={8}
                items={gemeenten}
                validationMessage={errors ? errors.gemeente : ''}
                validationMessageType={validationMessageType}
            />
        </Row>
        <Row>
            <Button text="Positioneer op kaart" disabled={disabled} className="o-col-4" style={{ marginLeft: '0.8333%', marginRight: '0.8333%', marginTop: '0.8333%' }} onClick={mapOnGetGeoCoordinates} />

            <ValidationGroup
                cols={8}
                colsBefore={4}
                validationMessages={errors ? errors.hasCoordinatenLigging : undefined}
                validationMessageType={validationMessageType}>
                <TextInput
                    label="breedtegraad"
                    disabled
                    size={errors && errors.hasCoordinatenLigging ? 6 : 4}
                    value={newCoords.lat}
                    name="breedtegraad" />
                <TextInput
                    label="lengtegraad"
                    disabled
                    size={errors && errors.hasCoordinatenLigging ? 6 : 4}
                    value={newCoords.lng}
                    name="lengtegraad" />
            </ValidationGroup>
            {hasCoordinates ?
                <div>
                    <Fieldset>
                        <Row>
                            <Map
                                mapName={mapKey}
                                geoToolboxUrl={geoToolboxUrl}
                                maxMapFeaturesToLoad={maxMapFeaturesToLoad}
                                baseLayerUrl={osmBaseLayerUrl}
                                baseLayerAttribution='&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors, Tiles courtesy of <a href="https://geo6.be/">GEO-6</a>'
                                children={mijnProjectMarkers}
                                zoom={15}
                                showEmptyMap
                                hideLegende
                                onlyBaseLayers
                                customCenter={center}
                            />
                        </Row>
                        <Row><br />
                            {inEditMode === false ? <span><Button onClick={onReplacePoint} text={'Wijzig ligging op kaart'} disabled={disabled} /> <Tooltip text={WIJZIG_MAP} tooltipType={types.TOOLTIP_INFO} windowWidth={35} windowAlignRight={false} /></span> : ''}
                            {inEditMode === true ? <Button onClick={saveNewPoint} text={'Bewaar'} /> : ''}
                            {inEditMode === true ? <Button onClick={cancelReplace} text={'Annuleer'} /> : ''}
                        </Row>
                    </Fieldset>
                    {isNieuwbouw || isRenovatie ?
                        <Fieldset title="Sportinfrastructuren in het project">
                            {isNieuwbouw ?
                                <ValidationGroup
                                    cols={12}
                                    colsBefore={4}
                                    validationMessages={errors ? errors.sportInfrastructurenNieuwbouw : undefined}
                                    validationMessageType={validationMessageType}>
                                    <FieldsetSubHeader>Nieuwbouw</FieldsetSubHeader>
                                    <p>
                                        Bevat uw project werkzaamheden aan de randaccomodatie van een bestaande openlucht sportinfrastructuur (vb. bouwen van kleedkamers, plaatsen van omheiningen of verlichtingspalen) dan is dit geen nieuwbouw maar moeten deze werkzaamheden opgegeven worden als renovatiewerkzaamheden aan de bestaande openlucht sportinfrastructuur.
                                    </p>
                                    {sportInfrastructurenNieuwbouw && sportInfrastructurenNieuwbouw.length > 0 ?
                                        <NieuwbowInfrastructurenTable
                                            infrastructurenInDeBuurt={sportInfrastructurenNieuwbouw}
                                            disabled={disabled}
                                            onChange={onChange}
                                            onEdit={onEditInfrastructuur}
                                            onDelete={onDeleteNieuwbouwInfrastructuur}
                                            soortenInfrastructuur={soortenInfrastructuur}
											soortenInfrastructuurAll={soortenInfrastructuurAll}
                                        />
                                        : <br />}
                                    <Row>
                                        <Button text="Voeg nieuwbouw sportinfrastructuur toe" disabled={disabled} className="o-col-6" onClick={onAddNieuwbouwInfrastructuur} />
                                    </Row>
                                    <br />
                                </ValidationGroup>
                                : null
                            }
                            {isRenovatie ?
                                <ValidationGroup
                                    cols={12}
                                    colsBefore={4}
                                    validationMessages={errors ? errors.sportInfrastructurenRenovatie : undefined}
                                    validationMessageType={validationMessageType}>
                                    <FieldsetSubHeader>Renovatie</FieldsetSubHeader>
                                    {sportInfrastructurenRenovatie.length > 0 ?
                                        <p>
                                            De sportinfrastructuren die opgenomen zijn in onze sportdatabank en die zich bevinden in de buurt van het opgegeven adres, zijn weergegeven op de kaart en in de tabel. <br />
                                            <div style={{ fontWeight: "bold" }}>Duid hieronder aan welke sportinfrastructuren je gaat renoveren in het project waarvoor je de subsidie aanvraagt.</div><br />
                                            Pas op! Deze sportinfrastructuren moeten op hetzelfde adres liggen.<br />
                                        </p> :
                                        <p>
                                            Er werden in onze sportdatabank geen sportinfrastructuren gevonden die zich bevinden in de buurt van het opgegeven adres.
                                            <div style={{ fontWeight: "bold" }}>Voeg hier de bestaande sportinfrastructuur toe die je gaat renoveren in het project waarvoor je de subsidie aanvraagt.</div>
                                        </p>
                                    }
                                    {sportInfrastructurenRenovatie.length > 0 ?
                                        <InfrastructurenInDeBuurtTable
                                            infrastructurenInDeBuurt={sportInfrastructurenRenovatie}
                                            disabled={disabled}
                                            onChange={onChangeRenovatieTable}
                                            onEdit={onEditInfrastructuur}
                                            soortenInfrastructuur={soortenInfrastructuur}
											soortenInfrastructuurAll={soortenInfrastructuurAll}
                                        /> : <br />}
                                    <Row>
                                        <Button text="Voeg ontbrekende sportinfrastructuren toe" disabled={disabled} className="o-col-6" onClick={onAddInfrastructuur} />
                                    </Row>
                                </ValidationGroup>
                                : null
                            }
                        </Fieldset>
                        : null}
                    {simulatieDossier.verdwijnenErInfrastructuren.toString() !== "false" && sportInfrastructurenRenovatie && sportInfrastructurenRenovatie.filter(x => !!x.spakki).length > 0 ?
                        <ValidationGroup
                            cols={12}
                            colsBefore={4}
                            validationMessages={errors ? errors.verdwijnendeInfrastructuren : undefined}
                            validationMessageType={validationMessageType}>
                            <Fieldset title="Bestaande sportinfrastructuren die zullen verdwijnen" >
                                <VerdwijnendeInfrastructurenTable
                                    infrastructuren={sportInfrastructurenRenovatie.filter(x => !!x.spakki)}
                                    onChange={onChangeVerdwijnendeInfrasTable}
                                    soortenInfrastructuur={soortenInfrastructuur}
									soortenInfrastructuurAll={soortenInfrastructuurAll}
                                />
                                <CheckBoxWithChild
                                    name={"verdwijnenErInfrastructurenNietInSpakki"}
                                    label={"De bestaande sportinfrastructuren die verdwijnen staan niet in de bovenstaande lijst."}
                                    value={simulatieDossier.verdwijnenErInfrastructurenNietInSpakki}
                                    onChange={onChange}
                                />
                            </Fieldset>
                        </ValidationGroup>
                        : null}
                </div>
                : null}
        </Row>
    </Fieldset>);
};

AdresFieldset.propTypes = {
    simulatieDossier: PropTypes.object,
    gemeenten: PropTypes.array.isRequired,
    postcodes: PropTypes.array.isRequired,
    errors: PropTypes.object,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onChangeRenovatieTable: PropTypes.func.isRequired,
    onChangeVerdwijnendeInfrasTable: PropTypes.func.isRequired,
    onEditInfrastructuur: PropTypes.func.isRequired,
    onAddInfrastructuur: PropTypes.func.isRequired,
    onAddNieuwbouwInfrastructuur: PropTypes.func,
    onDeleteNieuwbouwInfrastructuur: PropTypes.func,
    onGetGeoCoordinates: PropTypes.func.isRequired,
    mapKey: PropTypes.string,
    center: PropTypes.object.isRequired,
    soortenInfrastructuur: PropTypes.array,
	soortenInfrastructuurAll: PropTypes.array,
    createMapOptions: PropTypes.func,
    onReplacePoint: PropTypes.func,
    saveNewPoint: PropTypes.func,
    cancelReplace: PropTypes.func,
    inEditMode: PropTypes.bool,
    newCoords: PropTypes.object,
    draggable: PropTypes.bool,
    onClickTooltip: PropTypes.func,
    geoToolboxUrl: PropTypes.string,
    maxMapFeaturesToLoad: PropTypes.string,
    osmBaseLayerUrl: PropTypes.string,
    onMarkerDragEnd: PropTypes.func,
    validationMessageType: PropTypes.string
};

export default AdresFieldset;
